import React from 'react';
import { BeakerIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function ProjectDemonstration(props) {
  const { project } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="How learning will be demonstrated"
      icon={BeakerIcon}
      subtitle={project.data.demonstration || '(not provided)'}
      onClick={() => history.push(Urls(project).DEMONSTRATION)}
    />
  );
};
